import { render, staticRenderFns } from "./ChevronUp.vue?vue&type=template&id=4fe3474c"
import script from "./ChevronUp.vue?vue&type=script&lang=js"
export * from "./ChevronUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports